import store from '@/store'
import { slugify } from 'transliteration'

export default {
  computed: {
    filtersApplied () {
      // transform to object
      return [...this.filtersSimples]
        .reduce((res, {key, val}) => ({ ...res, [key]: val }), {})
    },

    filtersSimples: () => store.state.filters.simples || [],

    filtersPrice: () => store.state.filters.price || {},
    // Filters excluded for which a tag won't be shown in the filter-cloud
    excludedKeys: () => ['page', 'q', 'category', 'distance', 'notFound', 'pubs', 'republish_token'],
    // filter is shown even the user already selected it
    recursiveKeys: () => ['category'],
    // Pages where certain filters / buckets are excluded
    simplePages: () => ['userPublications', 'userFavorites', 'userFollowedUserPublications'],
    // Filters / buckets that are to be excluded in the above pages
    excludedFilters: () => ['category'],

    minPriceFilter: () => store.state.filters.price.min,

    maxPriceFilter: () => store.state.filters.price.max,

    activeOrderFilters () {
      const orderQuery = this.filtersSimples && this.filtersSimples.filter(f => f.key.startsWith('sort_by_'))
      return orderQuery.length > 0
    }
  },

  methods: {
    slugify,

    filtersUpdateRouter (newPath) {
      let location;
      location = this.noLocation ? {} :
        {
          ...store.getters['filters/location'],
          distance: store.state.search.distance
        }
      if(typeof this.noLocation == 'undefined') {
        location.lat = localStorage.getItem('lat');
        location.lon = localStorage.getItem('lon');
        location.city = localStorage.getItem('city');
      }
      const query = {
        ...this.filtersApplied,
        ...location,
        page: 1
      }

      // If newPath is passed asparameter, use it to redirect
      const path = newPath ? newPath : this.$route.path
      this.$router.push({ path, query })
    },

    filtersLocationChanged () {
      if (!this.noLocation) store.dispatch('filters/setLocation')
      this.filtersUpdateRouter()
    },

    filtersAddSimple (payload) {
      store.dispatch('filters/addSimple', payload)
      // If the filter being added is for category and if within CategoryPage component
      // add the slugified category to the path, replacing previous category value
      // and update router with new path
      if (payload.key.startsWith('category') && this.$route.name === 'category') {
        console.log(payload);
        let newCat = payload.val.split('_')
        newCat.pop()
        newCat = this.slugify(newCat.join('_'))
        const replaceCat = this.$route.path.split('/')
        replaceCat.pop()
        replaceCat.push(newCat)
        this.filtersUpdateRouter(replaceCat.join('/'))
      }
      else
        this.filtersUpdateRouter()
    },

    filtersRemoveSimple (filter) {
      store.dispatch('filters/removeSimple', filter)
      // If the filter being removed is for category and if within CategoryPage component
      // remove the slugified category from the path and add 'todas'
      // and update router with new path
      if (filter.key.startsWith('category') && this.$route.name === 'category') {
        const removeCat = this.$route.path.split('/')
        removeCat.pop()
        removeCat.push('todas')
        this.filtersUpdateRouter(removeCat.join('/'))
      }
      else
        this.filtersUpdateRouter()
      // this.pushToDataLayer('Filters', 'Remove filter')
    },

    filtersSetPrice (payload) {
      const min = payload.min
      const max = payload.max
      if (min)
        this.filtersAddSimple({ key: 'min_Precio mínimo', val: `${min}_${min}` })
      if (max)
        this.filtersAddSimple({ key: 'max_Precio máximo', val: `${max}_${max}` })
      store.dispatch('filters/setPrice', payload)
      this.filtersUpdateRouter()
    },

    filtersSetDistance (dist) {
      store.dispatch('setDistance', parseInt(dist))
      // this.pushToDataLayer('Filters', 'Remove Distance filter')
      this.filtersUpdateRouter()
    },

    filtersSetLocation (location) {
      store.dispatch('filters/setLocation', location)
      this.filtersUpdateRouter()
    }
  },

  created () {
    store.dispatch('filters/setSimples', this.filters)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/filters.js